const Header = () => {
    return (
        <div className="mb-10 font-mono text-center">
            <div className="inline-block mt-20 mb-5 mr-4 text-5xl font-bold">呀拉缩短链</div>
            <div className="inline-block pl-4 text-xl font-normal border-l-4 border-black">简单易用的专业短链接生成工具，链接永久有效！</div>
        </div>
    );
}

export default Header;